/**
 * tag模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const tag = {
  // 更新标签
  exportTags(params) {
    return $http.post(`${global.API_URL}/sme/tag/exportTags`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  },
  // 同步标签
  synchronizationTags(params) {
    return $http.post(`${global.API_URL}/sme/tag/synchronizationTags`,params);
  },
  // 查询标准标签
  queryStandardTagsByTagKey(params){
    return $http.post(`${global.API_URL}/sme/standardTagKey/queryStandardTagsByTagKey`,params);
  },
  // 删除标准标签
  delStandardTagById(id,params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/standardTagKey/delStandardTagById`,param);
  },
  // 添加标准标签
  addStandardTag(params){
    return $http.post(`${global.API_URL}/sme/standardTagKey/addStandardTag`,params);
  },
  // 查询资源标签
  queryAWSResourceTagsByTagKey(params){
    return $http.post(`${global.API_URL}/sme/resourceTagRelationship/queryAWSResourceTagsByTagKey`,params);
  },
  // 更新资源标签
  updateResourceStandardTagValue(params){
    return $http.post(`${global.API_URL}/sme/resourceTagRelationship/updateResourceStandardTagValue`,params);
  },
  // 查询所有标准标签
  getStandardTagList(){
    return $http.post(`${global.API_URL}/sme/standardTagKey/queryStandardTags`);
  },
  // 根据公司查询所有标准标签
  getStandardTagListByCompanyId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/standardTagKey/getStandardTagListByCompanyId`,param);
  },
  // 查询标签组
  queryTagGroupByTagKey(params){
    return $http.post(`${global.API_URL}/sme/resourceTagRelationship/queryAWSResourceTagGroupByTagKey`,params);
  },
  // 添加映射标签
  addMappingTag(params){
    return $http.post(`${global.API_URL}/sme/standardTagKeyRelationship/addStandardTagMapping`,params);
  },
  // 查询映射标签
  queryMappingTagByTagKeyId(params){
    return $http.post(`${global.API_URL}/sme/standardTagKeyRelationship/queryAWSResourceTagGroupByTagKeyId`,params);
  },
  // 删除映射标签
  delMappingTagById(id,params){
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/standardTagKeyRelationship/delMappingTagById`,param);
  },
  //导出
  exportResourceTags(params) {
    return $http.post(`${global.API_URL}/sme/resourceTagRelationship/exportResourceTags`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  }
}

export default tag;



// WEBPACK FOOTER //
// ./src/api/tag.js